export default class Martyr
{
    constructor(instructions, specifications, injured_info, family_info){
        this.instructions       = instructions
        this.specifications     = specifications
        this.injured_info       = injured_info
        this.family_info        = family_info
    }
    


    toFormData(){
        let fData = new FormData()
        
        //مواصفات الوحدة السكنية 
        fData.append('housing_city_id', this.specifications.city_id);
        fData.append('housing_housing_unit_id', this.specifications.name_residential_unit_id);
        fData.append('housing_housing_unit_type_id', this.specifications.type_residential_unit_id);
        // fData.append('housing_housing_build_style_id', this.specifications.style_residential_unit_id);
        fData.append('housing_housing_unit_area_id', this.specifications.area_residential_unit_id);

        //مقدم الطلب:
        // wounded_grants[0]:1
        // wounded_grants[1]:2

        // معلومات الجريح 
        fData.append('wounded_name1', this.injured_info.name1);        
        fData.append('wounded_name2', this.injured_info.name2); 
        fData.append('wounded_name3', this.injured_info.name3);                   
        fData.append('wounded_name4', this.injured_info.name4);
        fData.append('wounded_family_name', this.injured_info.family_name);        
        fData.append('wounded_mother_name', this.injured_info.mother_name); 
        fData.append('wounded_birth_date', this.injured_info.birth_date);                   
        fData.append('wounded_gender_id', this.injured_info.gender_id);
        fData.append('wounded_phone', this.injured_info.phone1);        
        fData.append('wounded_phone2', this.injured_info.phone2);
        fData.append('wounded_marital_status_id', this.injured_info.marital_status_id); 
        fData.append('wounded_certificate_id', this.injured_info.certificate_id);                   
        fData.append('wounded_specialization', this.injured_info.academic_specialization);
        fData.append('wounded_dept', this.injured_info.dept);
        fData.append('wounded_disability_ratio', this.injured_info.disability_ratio);
        fData.append('wounded_date_wound', this.injured_info.injury_date);
        fData.append('wounded_place_wound', this.injured_info.scene_accident);
        fData.append('wounded_date_hire', this.injured_info.employment_date);
        
        if(this.injured_info.id_type == '1'){
            fData.append('wounded_nationality_number', this.injured_info.nationality_number);
        }else{
            fData.append('wounded_national_id_number', this.injured_info.national_id_number);
            fData.append('wounded_national_id_number_record', this.injured_info.national_id_number_record);
            fData.append('wounded_national_id_number_paper', this.injured_info.national_id_number_paper);
        }
        
        fData.append('wounded_address_city_id', this.injured_info.city_id);        
        fData.append('wounded_address_district', this.injured_info.district); 
        fData.append('wounded_address_region', this.injured_info.region);                   
        fData.append('wounded_address_mahla', this.injured_info.mahla);
        fData.append('wounded_address_zqaq', this.injured_info.zqaq);        
        fData.append('wounded_address_dar', this.injured_info.dar);

        fData.append('wounded_housing_info_real_estate_id', this.injured_info.own_property_id);
        fData.append('wounded_housing_info_accommodation_id', this.injured_info.house_type_id);                   
        fData.append('wounded_housing_info_build_material_type_id', this.injured_info.construction_type_id);
        fData.append('wounded_housing_info_address_privacy_id', this.injured_info.housing_privacy_id);        
        fData.append('wounded_housing_info_building_condition_id', this.injured_info.construction_condition_id); 
        fData.append('wounded_housing_info_area', this.injured_info.housing_area);
        fData.append('wounded_housing_info_floors_number', this.injured_info.number_floors);

            
        for (let i = 0; i < this.injured_info.health_status_id.length; i++) {
            const element = this.injured_info.health_status_id[i];
            fData.append('wounded_health_statuses['+i+']', element.id);            
        }

        if (this.injured_info.government_grants_id.findIndex((x)=>x.id== 10) == -1) {    
        for (let i = 0; i < this.injured_info.government_grants_id.length; i++) {
            const element = this.injured_info.government_grants_id[i];
                fData.append('wounded_grants['+i+']', element.id);
            }          
        }

        fData.append('wounded_have_martyr', this.injured_info.families_martyrs_id);
        if (this.injured_info.families_martyrs_id == 1 || this.injured_info.families_martyrs_id == 2) {
            fData.append('wounded_martyr_category_id', this.injured_info.martyr_class_id);
            fData.append('wounded_martyr_attachment', this.injured_info.attachment_families_martyrs);    
        }

        fData.append('wounded_still_in_service', this.injured_info.continuing_serve_id);
        if (this.injured_info.continuing_serve_id == 0) {    
            fData.append('wounded_retirement_number', this.injured_info.retirement_number);
        }else{
            fData.append('wounded_q_card_number', this.injured_info.q_card_number);
        }

        fData.append('wounded_basic_attachment', this.injured_info.attachment_basic); 
        fData.append('wounded_wound_attachment', this.injured_info.attachment_disability_ratio);   
    

        // معلومات عائلة الجريح 
        for (let i = 0; i < this.family_info.fields.length; i++) {
            const element = this.family_info.fields[i];
            
            fData.append('wounded_family['+i+'][name1]', element.name1); 
            fData.append('wounded_family['+i+'][name2]', element.name2); 
            fData.append('wounded_family['+i+'][name3]', element.name3); 
            fData.append('wounded_family['+i+'][name4]', element.name4); 
    
            fData.append('wounded_family['+i+'][gender_id]', element.gender_id);
            fData.append('wounded_family['+i+'][relation_relative_id]', element.relative_relation_id); 
        }

        return fData
    }
}

